// extracted by mini-css-extract-plugin
export default {"placeholder":"typography_placeholder__HuqGq","pulse":"typography_pulse__1oijx"};